module.exports = __webpack_public_path__ + "static/img/sy_t4_1.94b6167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/sy_t4_1.png
// module id = xh7d
// module chunks = 16